import { createSlice } from '@reduxjs/toolkit';

const REDUCER_NAME = 'consultationView';

export const SUMMARY_TAB_INDEX = 0;
export const HISTORY_TAB_INDEX = 1;

export const initialState = {
  currentTabIndex: SUMMARY_TAB_INDEX,
  displayedTransition: null,
};

const slice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    navigate(state, action) {
      // If the user navigates to the history tab and there is no displayed transition,
      // we default to the comment transition.
      // TODO: check that that the comment transition exists in the workflow.
      if (action.payload.tabIndex === HISTORY_TAB_INDEX && state.displayedTransition == null && action.payload.hasCommentRights) {
        state.displayedTransition = 'comment';
      }
      // If the user navigates to the summary tab, we clear the displayed transition.
      if (state.currentTabIndex !== SUMMARY_TAB_INDEX && action.payload.tabIndex === SUMMARY_TAB_INDEX) {
        state.displayedTransition = null;
      }
      state.currentTabIndex = action.payload.tabIndex;
    },
    enterConsultationView(state) {
      state.currentTabIndex = SUMMARY_TAB_INDEX;
    },
    exitConsultationView(state) {
      state.currentTabIndex = SUMMARY_TAB_INDEX;
      state.displayedTransition = null;
    },
    displayTransition(state, action) {
      state.displayedTransition = action.payload.transition;
    },
  },
});

export const {
  navigate,
  displayTransition,
  enterConsultationView,
  exitConsultationView,
} = slice.actions;

export default slice.reducer;
